import { TypeKeys, ActionTypes } from '../actions/index';

const getInitialState = (): LocalSettingsState => {
  return {
    volume: 100,
    muted: false,
    duckBackgroundAudio: true,
    musicVolume: 40,
    mySworkit: 'calendar',
    voiceCommandsEnabled: false,
    dismissedPtDisclaimer: false,
    dismissedMSKDisclaimer: false,
    launchCount: 0,
  };
};

const localSettings = (
  state = getInitialState(),
  action: ActionTypes
): LocalSettingsState => {
  switch (action.type) {
    case TypeKeys.SET_VOICE_COMMANDS: {
      return { ...state, voiceCommandsEnabled: action.voiceCommandsEnabled };
    }
    case TypeKeys.SET_VOLUME: {
      return { ...state, volume: action.volume };
    }
    case TypeKeys.SET_MUTE: {
      return { ...state, muted: action.muted };
    }
    case TypeKeys.SET_AUDIO_DUCKING: {
      return { ...state, duckBackgroundAudio: action.duckBackgroundAudio };
    }
    case TypeKeys.MUSIC_VOLUME: {
      return { ...state, musicVolume: action.musicVolume };
    }
    case TypeKeys.SET_MY_SWORKIT: {
      return { ...state, mySworkit: action.mySworkit };
    }
    case TypeKeys.DISMISS_PT_DISCLAIMER: {
      return { ...state, dismissedPtDisclaimer: true };
    }
    case TypeKeys.DISMISS_MSK_DISCLAIMER: {
      return { ...state, dismissedMSKDisclaimer: true };
    }
    case TypeKeys.INCREASE_LAUNCH_COUNT: {
      const launchCount = state.launchCount ? state.launchCount + 1 : 1;
      return { ...state, launchCount };
    }
  }
  return state;
};

export default localSettings;
